/*
 * pop-payment-form directive to handle the payment form validation and credit card processing
 * 
 * pop-callback-success : Callback to be called on successful form submission
 * pop-callback-error : Callback to be called on error
 * pop-form-valid : Flag that holds the current form validity
 * pop-do-submit : Trigger (Boolean) to execute the form submission when true
 * pop-ajax-busy : Flag is set to true when the form is submitting
 */
var popDirectives = angular.module("pop.directives",['ui.sortable','ngRoute']);

popDirectives.filter('trusted', ['$sce', function ($sce) {
	return function(url) {
		return $sce.trustAsResourceUrl(url);
	};
}]);

popDirectives.filter('trustedHtml', ['$sce', function($sce){
	return function(text){
		return $sce.trustAsHtml(text);
	};
}]);

popDirectives.directive('popPaymentForm', function($http,$q){
	return {
		restrict: 'E',
		scope: {
			popCallbackSuccess: '=',
			popCallbackError: '=',
			popFormValid: '=',
			popDoSubmit: '=',
			popAjaxIndicator: '=',
			popCharge: '@'
		},
		templateUrl: '/js/app/views/payment-directive.html',
		link : function (scope, el, attr) {
			var endpoint = attr.popEndpoint || null,
				canceller;

			//watch the formPayment valid flag (in template) and notify the flag passed in popFormValid
			scope.$watch(function(){
				return scope.formPayment.$valid;
			},function(){
				scope.popFormValid = scope.formPayment.$valid;
			});
			
			/**
			 * Watch for payment form submission.
			 */
			scope.$watch(attr.popDoSubmit, function(value){
				//if its a literal true, then validate
				if(value === true) {
					doValidate(scope.formData);
				}
			});

			function doValidate(data) {
				if(endpoint) {
					//call endpoint
					$http.defaults.useXDomain = true;
					scope.popAjaxIndicator = true;

					if(canceller)
						canceller.resolve();

					canceller = $q.defer();

					$http({
						url: POP.apiBaseUrl + endpoint,
						method: 'POST',
						data: data,
						withCredentials: true,
						timeout: canceller.promise,
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
						}
					}).success(function(resp) {
						scope.popAjaxIndicator = false;
						if (resp.code === 200) {
							POP.attribute('payment-success', 1);
							POP.attribute('cc_on_file', 1);
						} else {
							POP.attribute('payment-failure', 1);
						}
						if(scope.popCallbackSuccess)
							scope.popCallbackSuccess(resp);
						
					}).error(function(resp) {
						scope.popAjaxIndicator = false;
						if(scope.popCallbackError)
							scope.popCallbackError(resp);
					});
				}
			}
		}
	}
});

popDirectives.directive('popTrack', function(){
	return {
		restrict: 'A',
		scope: {
			popTrack: '='
		},
		link: function(scope,el,attr){
			if(attr.ngShow)
			{
				scope.$parent.$watch(attr.ngShow, function(value,oldvalue){
					if(value)
					{
						if(typeof _kmq != 'undefined')
						{
							_kmq.push(['record', scope.popTrack ]);
						}
						if(typeof __insp != 'undefined')
						{
							__insp.push(['tagSession', scope.popTrack]);
						}
						POP.attribute('pop-track', scope.popTrack, true);
					}
				});
			}
			if(attr.ngHide)
			{
				scope.$parent.$watch(attr.ngHide, function(value){
					if(value)
					{
						if(typeof _kmq != 'undefined')
						{
							_kmq.push(['record', scope.popTrack ]);
						}
						if(typeof __insp != 'undefined')
						{
							__insp.push(['tagSession', scope.popTrack]);
						}
						POP.attribute('pop-track', scope.popTrack, true);
					}
				});
			}
			if(attr.ngIf)
			{
				scope.$parent.$watch(attr.ngIf, function(value){
					if(value)
					{
						if(typeof _kmq != 'undefined')
						{
							_kmq.push(['record', scope.popTrack ]);
						}
						if(typeof __insp != 'undefined')
						{
							__insp.push(['tagSession', scope.popTrack]);
						}
						POP.attribute('pop-track', scope.popTrack, true);
					}
				});
			}
		}
	}
});

/*
 * pop-modal directive to easily create modal windows with custom templates
 */
popDirectives.directive('popModal', function($location){
	return {
		restrict: 'E',
		transclude: true,
		template:'<div class="modal fade pop-modal" id="popModal" tabindex="-1" role="dialog" ng-transclude></div>',
		link: function(scope,el,attr) {
			
			var offset = attr.offset,
				$modal = $('.modal-dialog');

			//create modal instance
			var $modal = $(el.find('.pop-modal')).modal({
				keyboard: false,
				backdrop: 'static',
				show: false
			});

			$modal.on('hidden.bs.modal', function (e) {
				
				if(typeof attr.trigger != 'undefined')
					scope[attr.trigger] = false;

				scope[attr.modalShow] = false;
				$location.url('/');
				scope.$apply();
			});

			//listen for changes on modalShow flag
			scope.$watch(attr.trigger ? attr.trigger : attr.modalShow, function(value){
				if(value === true) {
					$modal.modal('show');
					if(typeof offset != 'undefined')
					{
						var $modalbackdrop = $('.modal-backdrop');
						$modal.css({top:offset+'px'});
						$modalbackdrop.css({top:offset+'px', zIndex:'2'});
					}
				} else {
					if(typeof offset != 'undefined')
					{
						var $modalbackdrop = $('.modal-backdrop');
						$modal.css({top:offset+'px'});
						$modalbackdrop.css({top:'0px', zIndex:'1000'});
					}
					$modal.modal('hide');
				}
			});

		}
	}
});

/*
 * pop-matrix-modal directive to include matrix anywhere
 */ 
popDirectives.directive('popMatrixModal', function(popFeatures){
	return {
		restrict: 'E',
		templateUrl:'/js/app/views/matrix-directive.html',
		link: function(scope,el,attr) {
			popFeatures.service(scope);
		}
	}
});

/*
 * pop-service-reg directive
 */ 
popDirectives.directive('popServiceReg', function(popFeatures){
	return {
		restrict: 'E',
		templateUrl:'/js/app/views/service-directive.html',
		link: function(scope,el,attr) {
            el.addClass('pop-service-reg');
			popFeatures.service(scope,false, attr.selectedPlan);
		}
	}
});

/*
 * pop-import-contacts directive
 */ 
popDirectives.directive('popImportContacts', function(popImporter){
	return {
		restrict: 'E',
		templateUrl:'/js/app/views/import-contacts-directive.html',
		link: function(scope,el,attr) {
			popImporter.service(scope);
		}
	}
});


/*
 * pop-luhn directive for credit card number validation
 */
popDirectives.directive('popLuhn', function(){
	return {
		restrict: 'A',
		require: 'ngModel',
		scope: {
			ngModel: '='
		},
		controller: '',
		link: function(scope,el,attr, ctrl){
			/*takes the form field value and returns true on valid number*/
			var value = el.val();
			/*accept only digits, dashes or spaces*/
			if (/[^0-9-\s]+/.test(value)) return false;

			/* The Luhn Algorithm. It's so pretty.*/
			var nCheck = 0, nDigit = 0, bEven = false;
			value = value.replace(/\D/g, "");

			for (var n = value.length - 1; n >= 0; n--) {
				var cDigit = value.charAt(n),
				nDigit = parseInt(cDigit, 10);

				if (bEven) {
					if ((nDigit *= 2) > 9) nDigit -= 9;
				}

				nCheck += nDigit;
				bEven = !bEven;
			}
			ctrl.$setValidity('validcc',(nCheck % 10) == 0);
		}
	}
});


/*
 * pop-match-value - pass a ngmodel value {{ngmodel}}
 */
popDirectives.directive('popMatchValue', function() {
	return {
		require: 'ngModel',
		link: function(scope, elem, attr, ngModel) {
			scope.$watch(attr.ngModel, function(){
				var isSame = ngModel.$modelValue === attr.popMatchValue;
				ngModel.$setValidity('popMatchValue', isSame);
			});
		}
	};
});

/*
 * pop-sanitize-input-match-pattern - pass a regex to match against, everything else will be sanitized
 */
popDirectives.directive('popSanitizeInputMatchPattern', function(){
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope,elem,attr,ngModel) {
			var orig = attr.popSanitizeInputMatchPattern;
			var reg = new RegExp(attr.popSanitizeInputMatchPattern,'g');

			scope.$watch(attr.ngModel, function(viewvalue){
				if(typeof viewvalue != 'undefined')
				{
					//also check if validation changed
					if(attr.popSanitizeInputMatchPattern != orig)
						reg = new RegExp(attr.popSanitizeInputMatchPattern,'g');

					ngModel.$setViewValue(viewvalue.replace(reg,''));
					ngModel.$render();
				}
			});
		}
	}
});


/*
 * pop-color-picker - pass ngModel
 */
popDirectives.directive('popColorPicker', function(){
	return {
		restrict: 'A',
		scope: {
			popColorPicker: '=',
			popColorTransparency: '='
		},
		link: function(scope,elem,attr,ngModel) {
			var color = hexToRgb(scope.popColorPicker);
			var $bgcolorcontainer = typeof attr.popColorUpdate != 'undefined' ? $('.' + attr.popColorUpdate) : null;
			
			if(color != null)
			{
				elem.css('background-color','rgba('+color.r+','+color.g+','+color.b+','+(typeof scope.popColorTransparency != 'undefined' ? scope.popColorTransparency/100 : '1')+')');
				if($bgcolorcontainer != null) $bgcolorcontainer.css('background-color','rgba('+color.r+','+color.g+','+color.b+','+(typeof scope.popColorTransparency != 'undefined' ? scope.popColorTransparency/100 : '1')+')');
			}

			$(elem).colpick({
				layout:'hex',
				submit:1,
				colorScheme:'dark',
				color: scope.popColorPicker,
				onChange:function(hsb,hex,rgb,el,bySetColor) {
					color = hexToRgb(hex);
					scope.$apply(function(){
						scope.popColorPicker = hex;
					});
					elem.css('background-color','rgba('+color.r+','+color.g+','+color.b+','+(typeof scope.popColorTransparency != 'undefined' ? scope.popColorTransparency/100 : '1')+')');
					if($bgcolorcontainer != null) $bgcolorcontainer.css('background-color','rgba('+color.r+','+color.g+','+color.b+','+(typeof scope.popColorTransparency != 'undefined' ? scope.popColorTransparency/100 : '1')+')');
				},
				onSubmit: function(){
					$(elem).colpickHide();
				}
			});

			scope.$parent.$watch(attr.popColorTransparency, function(value){
				var color = hexToRgb(scope.popColorPicker);
				if(color != null)
				{
					elem.css('background-color','rgba('+color.r+','+color.g+','+color.b+','+(typeof scope.popColorTransparency != 'undefined' ? scope.popColorTransparency/100 : '1')+')');
					if($bgcolorcontainer != null) $bgcolorcontainer.css('background-color','rgba('+color.r+','+color.g+','+color.b+','+(typeof scope.popColorTransparency != 'undefined' ? scope.popColorTransparency/100 : '1')+')');
				}
			});
			
			function hexToRgb(hex) {
				var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
				return result ? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16)
				} : null;
			}
		}
	}
});

/*
 * pop-check-plan
 * pop-check-plan = "<value>" specify a plan name
 */
popDirectives.directive('popCheckPlan', function($compile,$rootScope, popFeatures){

	return {
		restrict: 'A',
		priority: 0,
		link: function(scope,el,attr) {
			var $el = $(el);
			$el.bind('click', function(e){
				e.preventDefault();
				if(typeof scope.checkFeature === 'function') {
					scope.checkFeature(attr.popCheckPlan, e);
				} else {
					popFeatures.service(scope);
					scope.checkFeature(attr.popCheckPlan, e);
				}
			});
		}
	} 
});

/*
 * pop-editor-modal
 * pop-editor-modal = "<value>" specify a template name (just name, it will append "-tmpl.html" in code)
 * ng-model = "<model>" ngModel to update
 */
popDirectives.directive('popEditorModal', function(ngDialog,$compile,$rootScope,$timeout, $injector){
	var templates = {
		'text': '<span ng-bind-html="ngModel.site_desc | trustedHtml"></span>',
		'simple-text': '<span>{{temp}}</span>',
		'site-title': '<span>{{ngModel.site_title ? ngModel.site_title : "Add a title"}}</span>',
		'site-tagline': '<span>{{ngModel.site_tagline ? ngModel.site_tagline : "Add a subtitle"}}</span>',
		'other':''
	};

	function getTemplate(template){
		return templates[template];
	}

	return {
		restrict: 'A',
		transclude: true,
		priority: 2,
		link: function(scope,el,attr) {
			if(attr.popEditorModalTrigger != 'true')
			{
				if(attr.popEditorModal != 'image')
				{
					el.html(getTemplate(attr.popEditorModal));
					$compile(el.contents())(scope);
				}
				
				attr.popEditorRolloverIcon = attr.popEditorRolloverIcon ? attr.popEditorRolloverIcon : 'i-pencil-6';

				el.wrap('<div class="pop-editable clearfix"></div>');
				if(el.parent()[0].querySelector('.pop-editable-icon') === null)
				{
					el.parent().append('<div class="pop-editable-icon" title="Edit settings"><i class="'+attr.popEditorRolloverIcon+'"></i></div>');
				}
			}

			if(attr.popEditorService)
			{
				var service = $injector.get(attr.popEditorService);
				service.init(scope);
			}

			if(attr.popEditorTitle)
				scope.title = attr.popEditorTitle;

			var clickTarget = attr.popEditorModalTrigger != 'true' ? el.parent() : el;

			clickTarget.bind('click', function(event){
				if(event.isPropagationStopped() !== true) {
					//copy the content so we can edit without committing
					scope.block = scope.block;
					scope.field = attr.ngModel;
					scope.comingfrommodal = attr.popEditorComingFromModal;

					if(attr.popEditorModal == 'social')
					{
						scope.tempSelected = angular.copy(scope.selectedSocialIcons);
						scope.tempsocial = angular.copy(scope.socialIcons);
					}
					
					ngDialog.open({
						template:'/js/app/views/editor/' + attr.popEditorModal + '-tmpl.html',
						className: 'ngdialog-theme-plain draggable',
						scope: scope,
						closeByDocument: false,
						preCloseCallback: function() {
							//close open editor
							if($rootScope.currentSelectedBlock != null && typeof $rootScope.currentSelectedBlock != 'undefined')
							{
								$rootScope.closeEditor($rootScope.currentSelectedBlock, new Event('click'));
							}
						}
					});
				}
			});
		
			scope.saveSocial = function(value) {
				scope.selectedSocialIcons = value;
				$rootScope.renderSocialIcons(value);
				//$rootScope.saveChanges();
				if(scope.block)
				{
					$rootScope.saveBlockChange(scope.block);
				}
				scope.closeDialog();
			}

			//generic save method, param: value is a temporary model
			scope.saveDialog = function(){
				if(scope.block)
				{
					$rootScope.saveBlockChange(scope.block);
				}

				//$rootScope.applyChanges(value);
				//but also save the block and the page
				$rootScope.saveChanges();

				scope.closeDialog();	
			}

			//generic save method, param: value is a temporary model
			scope.saveBackground = function(){
				$rootScope.saveChanges(true);

				scope.closeDialog();	
			}

			scope.closeDialog = function(current, modal){
				if(modal === 'layout' || current === true)
				{
					ngDialog.close(ngDialog.latestID);
				} else {
					ngDialog.closeAll();
				}
			}

			scope.saveMapData = function(value) {
				var lat,
					lon,
					params,
					url,
					geocoder,
					coords = {};

				params = buildAddressString(value);
				geocoder = new google.maps.Geocoder();
				
				//console.log('Address: ' + params);
				$rootScope.ajax = true;

				if (geocoder) {
					geocoder.geocode({ 'address': params }, function (results, status) {
						
						$rootScope.$apply(function(){
							$rootScope.ajax = false;
						});

						if (status == google.maps.GeocoderStatus.OK) {
							coords = {
								lat: results[0].geometry.location.lat(),
								lon: results[0].geometry.location.lng()
							};

							value.address_lat = coords.lat;
							value.address_lon = coords.lon;

							value.show_map = parseInt(value.show_map);
							value.show_address = parseInt(value.show_address);
							
							scope.closeDialog();

							scope.$apply();

							/*
							scope.$apply(function(){
								scope.saveDialog(value);
							});
							*/

						} else {
							value.address_lat = '';
							value.address_lon = '';
							/*
							scope.$apply(function(){
								scope.saveDialog(value);
							});
							*/
							scope.$apply();

							POP.Message.show($('.ngdialog-content .alert'),'We had a problem getting your map coordinates. Your map will not show until a valid address is filled out.',false);
						}
					});
				} else {
					void 0;
				}
			}

			scope.selectCarousel = function(e) {
				scope.formData.site_bg_img = $(e.currentTarget).attr('src').replace("_sm","");
				//we should save form here
				//$rootScope.saveChanges();
			}
		}
	}
});

/*
 * pop-dialog
 * pop-dialog = "<value>" specify a template name (just name, it will append "-tmpl.html" in code)
 */
popDirectives.directive('popDialog', function(ngDialog,$compile,$rootScope, $timeout) {

    return {
        restrict: 'A',
        link: function (scope, el, attr) {
            el.bind('click', function (event) {
                event.preventDefault();
                ngDialog.open({
                    template: '/js/app/views/' + attr.popModal + '-tmpl.html',
                    className: 'ngdialog-theme-plain',
                    scope: scope,
					closeByDocument: false
                });
            });
            $rootScope.$on('ngDialog.opened', function (e, $dialog) {
                $timeout(function () {
                    var d = $($dialog).find('.ngdialog-content'),
                        w = d.outerWidth(),
                        h = d.outerHeight();

                    d.css({marginTop: -(h / 2), marginLeft: -(w / 2)});
                });
            });
        }
    }
});


/*
 * pop-html
 * pop-html = html code with angular directives
 */
popDirectives.directive('popHtml', function($compile, $rootScope){
	return {
		restrict: 'A',
		link: function(scope,el,attr){
			scope.$watch(attr.popHtml, function(value){
				el.html(value);
				$compile(el.contents())(scope);
			});
		}
	}
});

/*
 * pop-block-template - pass it a block and it renders based on block template and data
 */
popDirectives.directive('popBlockTemplate', function($compile){
	return {
		restrict: 'A',
		link: function(scope,el,attr){
			var html = '<div class="editor-block-toolbar"></div><div class="editor-block-content" ng-include="\'/js/app/views/blocks/'+ scope.block.template_source   +'.html\'"></div>';
			el.find('.container').append(html);
			$compile(el.contents())(scope);
		}
	}
});

/*
 * pop-editor-field
 */
popDirectives.directive('popEditorField', function($compile,$rootScope){
	return {
		restrict: 'A',
		link: function(scope,el,attr){
			el.html(scope.block.fields[attr.popEditorField]);
			if(el[0].querySelector('.pop-editable-icon') === null)
			{
				el.append('<div class="pop-editable-icon" title="Edit text"><i class="i-pencil-6"></i></div>');
			}
			
			if(el[0].getAttribute('contenteditable') != null)
			{
				POP.editor.create(el[0]);
			} else {
				//check his children
				var editors = el[0].querySelectorAll('[contenteditable="true"]');
				Array.prototype.forEach.call(editors, function(element, index){
					POP.editor.create(element);
					element.addEventListener('save:block', function(e){
						saveBlock(element);
					});
				});
				
				if(editors === null)
				{
					//super getto, but only way i can think of supporting legacy 3 column templates
					if(attr.popEditorField.indexOf('text_') != -1)
					{
						//first grab the title
						var h3 = el[0].querySelector('<h3>');
						if(h3)
						{
							h3.setAttribute('contentEditable', 'true');
							h3.setAttribute('editor-options', 'bold,italic,url,color,size,font,align');
						}

						//now grab the content
						var content = el[0].querySelector('p:first-child');
						var newcontent = createElement('div');

						if(content)
						{
							newcontent.innerHTML = content.innerHTML;
							content.parentElement.removeChild(content);
							newcontent.setAttribute('contentEditable', 'true');
							newcontent.setAttribute('editor-options', 'bold,italic,url,color,size,font,align');
							el[0].appendChild(newcontent);
						}
						
						//don't forget the save event listener
						if(content || h3)
						{
							el[0].addEventListener('save:block', function(e){
								saveBlock(el[0]);
							});
						}
					}
				}
			}

			//gotta capture save events here
			el[0].addEventListener('save:block', function(e){
				saveBlock(el[0]);
			});

			function saveBlock(element) {
				//remove icon first
				var icons = element.querySelectorAll('.pop-editable-icon')
				if(icons != null)
				{
					Array.prototype.forEach.call(icons, function(item,index){
						item.parentElement.removeChild(item);
					});
				} else {
					//check its parent, in the case of nested editors
					icons = element.parentElement.querySelectorAll('.pop-editable-icon')
					if(icons != null)
					{
						Array.prototype.forEach.call(icons, function(item,index){
							item.parentElement.removeChild(item);
						});
					}
				}

				scope.block.fields[attr.popEditorField] = el.html();
				//ok now add it again
				angular.element(element).append('<div class="pop-editable-icon" title="Edit text"><i class="i-pencil-6"></i></div>');
			}
		}
	}
});

/*
 * pop-editor-rollover
 */
popDirectives.directive('popEditorRollover', function($rootScope){
	return {
		restrict: 'A',
		link: function(scope,el,attr){
			var norollover = [
				"site-logo",
				"site-contact",
				"site-map",
				"site-social"
			];
			
			el.append('<div class="container" style="position:relative"></div>');
			var $container = el.find('.container');
			
			//add the class 
			el.off('click').on('click',function(e){

				//POP.scrollTo(el, false,0, 100);

				if($rootScope.currentSelectedBlock != el && norollover.indexOf(scope.block.name) == -1)
				{
					if($rootScope.currentSelectedBlock != null && typeof $rootScope.currentSelectedBlock != 'undefined')
					{
						$rootScope.closeEditor($rootScope.currentSelectedBlock);
					}
					
					$rootScope.currentSelectedBlock = el;
					$container.addClass('pop-editor-selected');
					POP.editor.canshow = true;
				}
			});
			el.off('keyup').on('keyup', function(e){
				if(e.which == 27)
				{
					$rootScope.closeEditor(el, new Event('click'));
				}
			});

			if(norollover.indexOf(scope.block.name) == -1)
			{
				$container.append('<div class="pop-editor-rollover"><ul class="pop-editor-bar"><li><a href="" ng-click="$root.closeEditor(null,$event)" class="pop-edit-icon btn-success" title="Save changes for this element"><i class="i-checkmark-circle"></i></a></li><li><a href="" onclick="document.execCommand(\'undo\', false, null);" class="pop-edit-icon btn-warning" title="Undo changes for this element"><i class="i-undo"></i></a></li><li><a href="" onclick="document.execCommand(\'redo\', false, null);" class="pop-edit-icon btn-warning" title="Redo changes for this element"><i class="i-redo"></i></a></li><li><a class="pop-edit-icon btn-info" pop-editor-modal="block" pop-editor-modal-trigger="true" ng-transclude ng-model="bg_image" title="Change background settings for this element"><i class="i-image-3"></i></a></li><li><a href="" ng-disabled="ajax" class="pop-edit-icon btn-danger" pop-editor-modal="confirm-delete" pop-editor-modal-trigger="true" ng-transclude title="Delete this element"><i class="i-remove-2"></i></a></li></ul></div>');
				scope.dontShowBar = true;
			}

			$rootScope.closeEditor = function(targetToClose, e) {
				
				if(e)
					e.stopPropagation();

				if(typeof targetToClose === 'undefined' || targetToClose === null)
					targetToClose = $rootScope.currentSelectedBlock;
				
				targetToClose.find('.container').removeClass('pop-editor-selected');

				$rootScope.currentSelectedBlock = null;

				POP.editor.blur();

				//go thru all pop-editors in this element and dispatch save event
				var editors = targetToClose[0].querySelectorAll('[contenteditable]');
				Array.prototype.forEach.call(editors, function(element,index){
					element.dispatchEvent(new Event('save:block'));
				});
			}

		}
	}
});

/*
 * pop-image-uploader Will prompt you to upload image and populate model with filepicker url
 */
popDirectives.directive('popImageUploader', function(){
	return {
		restrict: 'A',
		link: function(scope,el,attr){

			// initialize filepicker
			if (typeof filepicker != 'undefined') { 
				filepicker.setKey('AaMRiZTfvTFS1fRzbZ4F4z'); 
			}
			
			//only for "image" templates TODO: separate into its own file
			scope.fileUpload = function(model, field) {
				filepicker.pickAndStore(
					// data
					{ 
						mimetypes: ['image/*'], 
						container: 'modal', 
						maxSize: 500000 
					},
					{
						location: "S3",
					    path: '/domains/' + POP.currentDomain.domain + '/',
					    access: 'public'
					},
					function(image) {
		                if (typeof image.url == 'undefined') {
		                    image = image[0];
		                }

						void 0;

		                var s3Path = 'http://pop-profiles.s3.amazonaws.com/' + image.key;
                		void 0;

						switch(field) {
							case 'bg':
								scope.formData.site_bg_img = s3Path;
							break;
							case 'seo':
								scope.formData.seo_ogimage = s3Path;
							break;
							default:
								//set ngModel to image.url
								model.fields[field] = s3Path;
							break;
						}
						scope.$apply();
					},

					// error callback
					function(FPError) {
						if (FPError.code == 101) {
							return;
						}

						// output that there was an error with the upload attempt
						POP.form.message.show(
							'We had a hiccup. Please try uploading your image again.'
						);
					});
			}

			el.bind('click', function(e){
				e.preventDefault();
				scope.fileUpload(scope.block, attr.popImageUploader);
			});
		}
	}
});

/*
 * pop-image-remover Will remove image from filepicker
 */
popDirectives.directive('popImageRemover', function($rootScope){
	return {
		restrict: 'A',
		link: function(scope,el,attr){

			//initialize filepicker
			if(typeof filepicker != 'undefined') { filepicker.setKey('AaMRiZTfvTFS1fRzbZ4F4z'); }
			
			//only for "image" templates TODO: separate into its own file
			scope.fileRemove = function(model) {
				if(model.name == "site_logo")
				{
					$rootScope.removeBlock(model);
				} else {
					//we need to reset back to default value
					//model.fields[attr.popImageRemover] = '';
					model.fields[attr.popImageRemover] = model.fields[attr.popImageRemover + '_default_value'];
					//and we always have to save block
					$rootScope.saveBlockChange(model);
				}
				/*
				filepicker.remove({url:model.fields[attr.popImageRemover].replace(/\/convert\?rotate=exif$/,'')},
					function(){
						$rootScope.ajax = false;
						if(model.name == "site_logo")
						{
							$rootScope.removeBlock(model);
						} else {
							//we need to reset back to default value
							//model.fields[attr.popImageRemover] = '';
							model.fields[attr.popImageRemover] = model.fields[attr.popImageRemover + '_default_value'];
							//and we always have to save block
							$rootScope.saveBlockChange(model);
						}
						scope.$apply();
						//close Editor?
					}, function(FPError){
						$rootScope.ajax = false;
						if(FPError.code == 172 || FPError.code == 171)
						{
							//couldn't find image in filepicker, check if this is a single image and remove block if it is
							if(model.name == "site_logo")
							{
								$rootScope.removeBlock(model);
							} else {
								model.fields[attr.popImageRemover] = model.block_fields[attr.popImageRemover];							}

							scope.$apply();
						}
				});
				*/
			}
			
			
			el.bind('click', function(e){
				e.preventDefault();
				
				switch(attr.popImageRemover)
				{
					case 'bg':
						scope.formData.site_bg_img = "";
					break;
					case 'seo':
						scope.formData.seo_ogimage = "";
					break;
					default:
						//set ngModel to image.url
						scope.fileRemove(scope.block);
					break;
				}
				scope.$apply();
			});
		}
	}
});



/*
 * popBlocks service, all logic for blocks 
 */
popDirectives.factory("popBlocks", function($rootScope){
	service = {
		init : function(scope){
			var $scope = scope;

			$scope.checkboxes = [];

			//change layout and set sort_order
			$scope.saveLayoutOrder = function(data){
				//iterate thru array of section blocks
				for( var i = 0; i < data.sections.length; i++ )
				{
					for( var j = 0; j < data.sections[i].page_blocks.length; j++ )
					{
						//set sort_order to array index
						data.sections[i].page_blocks[j].sort_order = j;
					}
				}

				//save page
				//$rootScope.saveChanges();
				$scope.closeDialog();
			}

			$rootScope.removeBlock = function(block, comingfrommodal){

				$scope.closeDialog(false,comingfrommodal);

				if(block.name == 'site-map')
				{
					//reset lat/long
					$scope.formData.address_lat = '';
					$scope.formData.address_lon = '';
					$scope.formData.address_street1 = '';
					$scope.formData.address_street2 = '';
					$scope.formData.address_city = '';
					$scope.formData.address_state = '';
					$scope.formData.address_zip = '';
			  		$scope.formData.address_country = '';
				}
				
				block.is_deleted = 1;
				
			}

			$rootScope.saveBlockChange = function(block) {
				//we need to get all redactor instances first
				$scope.closeDialog();
			}

			$scope.addBlocks = function(){
				var section = scope.formData.sections[0];
				//go thru checkboxes
				for(var i=0; i < $scope.blockTemplates.length; i++)
				{
					if($scope.checkboxes[i] === true)
					{
						//get template for each block
						//add to section.page_blocks
						var block = angular.copy($scope.blockTemplates[i]);
						block.section_id = section.section_id;
						block.profile_id = section.profile_id;
						block.sort_order = $scope.formData.sections[0].page_blocks.length;
						
						$scope.formData.sections[$scope.formData.sections.length-1].page_blocks.push(block);
					}
				}

				$scope.closeDialog();
			}
		}
	}

	return service;
});

/*
 * popProfile service, all logic for old profile fields should be in here
 */
popDirectives.factory("popProfile", function(){
	service = {
		init : function(scope){
			var $scope = scope;

			//do all logic here
		}
	}

	return service;
});

/*
 * popImporter service, all logic is in here
 */
popDirectives.factory("popImporter", function($rootScope,$interval){
	
	service = {

		service : function(scope) {
			var $scope = scope;

			$scope.step = 1;
			$scope.counter = 0;

			$scope.checkbox = [];

			$scope.updateCounter = function(index){
				if($scope.checkbox[index] === true && $scope.counter > 0)
					$scope.counter--;
				if($scope.checkbox[index] === false)
					$scope.counter++;
			};

			$scope.$watch('showContactsModal', function(){
				if($scope.showContactsModal === true)
					$scope.step = 1;
			});

			$scope.contactList = [];

			$scope.nextStep = function(){
				//first lets make sure we can get all that data, on success change step to 2
				//$scope.step = 1.1;
				
				var newWindow = window.open('', 'name', 'height=600,width=450');

				ajaxWrapper('GET', null, '/oauth/google', 
					function(resp){
						if(typeof resp.url != 'undefined')
						{
							newWindow.location = resp.url;
							if (window.focus) {
                                newWindow.focus();
							}
							$rootScope.ajax = true;
							$rootScope.$apply();
						}
					},
				function(err){}, true, $rootScope);
				
				window.authReady = function(data){
					$scope.step = 2;
					$scope.contactList = data;
					$scope.$apply();

					$rootScope.ajax = false;
					$rootScope.$apply();
				};
				
			}

			$scope.selectAll = function(){
				$scope.counter = 0;
				for(var i=0; i < $scope.contactList.length; i++)
				{
					$scope.checkbox[i] = !$scope.checkbox[i];
					if($scope.checkbox[i] === true)
						$scope.counter++;
				}
			}
			
			$scope.importContacts = function(){
				var data = {
					account : POP.currentDomain.appusers[0].email,
					domain_id: POP.currentDomain.id,
					contacts : []
				};

				//get selected contacts first
				for(var i=0; i < $scope.contactList.length; i++)
				{
					if($scope.checkbox[i] === true)
					{
						data.contacts.push($scope.contactList[i]);
					}
				}

				//call api to add them to simplemail
				ajaxWrapper('POST',
					JSON.stringify(data),
					POP.apiBaseUrl + '/services/atmail/contacts',
						function(resp) {
							//on success hide everything and show thank you page
							if(resp.code === 200)
							{
								//$scope.successMessage = resp.data.message
								$scope.successMessage = resp.msg + '<br><strong>' + resp.data.message[0] + '</strong>';
								$scope.step = 3;
								$scope.$apply();
							} else {
								POP.Message.response($('#modalMessageBox'),resp);
							}
						},
					function(error) {
						//error
						POP.Message.response($('#modalMessageBox'),error);
					}, true, $rootScope);
			}

		}
	}

	return service;
});


popDirectives.factory("popFeatures", function($rootScope,$interval, $location, $route){
	
	service = {

		service : function(scope, modal, plan) {
			var $scope = scope,
				ismodal = modal == false ? false : true;
			
			$scope.service = POP.currentService.data.service;
			$scope.currentPlan = POP.currentServicePlans.json.current_plan;
			$scope.currentServicePlans = POP.currentServicePlans;
			$scope.currentDomain = POP.currentDomain;
			$scope.dnsRecords = [];

			$scope.complete = function(){
				$scope.showModal = false;
				$rootScope.ajax = true;
				//this means its coming from somewhere outside of panel service reg modal
				if(ismodal === false){
					location.href = '/panel';
				} else {
					//only way now is to refresh page
					location.reload();
				}
				//loadServiceDetails();
			}

			$scope.dismissModal = function() {
				void 0;
				$scope.showModal = false;
			}

			$scope.openPlanModal = function(action){
				// hide any error messages
				POP.Message.hide();

				$rootScope.showSuccessMsg = '';

				$scope.checkforbilling = false;
				$scope.ctaAction = action;
				$scope.matrixText = null;
				$scope.dnsRecords = [];
				$scope.mailDnsRecords = false;
				$scope.skipDns = false;

				$scope.hideModalViews();
				if(ismodal)
					$scope.showModal = true;

				if (POP.currentServicePlans.json.features.length == 0 || Object.keys(POP.currentServicePlans.json.plans).length == 0) {
					$scope.showMatrix = false;
				} else {
					$scope.showMatrix = true;
				}

				switch (action) {
					case "cancel":
						// show cancel confirm
						$scope.showMatrix = false;
						$scope.showCancelConfirm = true;
						break;
					case "activate-free":
						// no need to check for billing enabled
						$rootScope.getPlan(POP.currentServicePlans.json.plans[Object.keys(POP.currentServicePlans.json.plans)[0]].plan_info.slug);
						break;
					case "activate-paid":
						//check for billing enabled
						$scope.checkforbilling = true;
						if ($scope.showMatrix === false) {
							//if there's no matrix, ie (1) plan, get the first plan in their Object.keys(obj)[0]
							$rootScope.getPlan(POP.currentServicePlans.json.plans[Object.keys(POP.currentServicePlans.json.plans)[0]].plan_info.slug);
						}
						break;
					case "show-plans":
						//show plans straight up
						$scope.showMatrix = true;
						$scope.showConflictsConfirm = false;
						break;
					case 'reactivate':
						$scope.showMatrix = false;
						$scope.changePlan();
						break;
				}
			}

			$scope.checkFeature = function(feature, event){
				$scope.checkAccess(feature, event);
			}

			$scope.checkAccess = function(feature, event) {
				var hasAccess = checkAccesstoFeature(feature);
				if (hasAccess == false) {
					event.stopPropagation();

					//get which plan first
					var plan = whichPlanforFeature(feature);
					
					//show matrix
					$scope.openPlanModal('show-plans');
					if (typeof plan.plan_info != 'undefined') {
						$scope.matrixText = "You need to upgrade to the <strong>" + 
							plan.plan_info.short_name + 
							" plan</strong> to use the <strong>" 
							+ plan.feature_title  + "</strong> feature.";
					}
					$scope.$apply();
				} else {//access
					$scope.dismissModal();
					$scope.changeElement();
				}
			}

			// check if user has access to this plan
			function checkAccesstoFeature(feature) {
				var feature_plan, feature_title, plan_title;
				
				// first check if we have access in current plan
				var current_plan_features = POP.currentServicePlans.json.plans[$scope.currentPlan.slug].features;

				for(var i = 0; i < current_plan_features.length; i++) {
					if (current_plan_features[i].slug === feature && current_plan_features[i].is_hidden != 1) {
						return true;
					}
				}

				return false;
			}

			function whichPlanforFeature(feature) {
				var plan_obj = {};
				var features,found = false;
				for (var plan in POP.currentServicePlans.json.plans) {
					if (POP.currentServicePlans.json.plans.hasOwnProperty(plan)) {
						features = POP.currentServicePlans.json.plans[plan].features;
						for(var i=0; i < features.length; i++)
						{
							if(features[i].slug === feature && features[i].is_hidden != 1)
							{
								plan_obj = POP.currentServicePlans.json.plans[plan];
								plan_obj.feature_title = features[i].name;
								found = true;
								break
							}
						}
						if(found) break;
					}
				}

				return plan_obj;
			}

			/*
			 * cancel service registration
			 */
			$scope.cancelService = function() {
				ajaxWrapper('DELETE',
					null,
					POP.apiBaseUrl + '/services/' + $scope.service.slug + '/' + POP.currentDomain.id,
					function(resp) {
						//on success hide everything and show thank you page
						if(resp.code === 200)
						{
							void 0;
							$scope.showCancelConfirm = false;
							$scope.showCancelModal = false;
							$rootScope.success = true;
							$scope.$apply();
							$rootScope.$apply();
							location.reload();
						} else {
							$rootScope.cancelError = resp.msg;
							if($scope.service.slug == 'atmail')
							{
								$rootScope.showGappsLink = true;
							}
							if($scope.service.slug == 'gapps')
							{
								$rootScope.showSimpleMailLink = true;
							}
							$rootScope.$apply();
						}
					},
					function(resp) {
						//error
					}, true, $rootScope);

			}

			/**
			 * Handle the user selecting a plan from the matrix (or other means).
			 */
			$rootScope.getPlan = function(plan) {
				// track here
				if(typeof _kmq != 'undefined') {
					_kmq.push(['record','Service-' + $scope.service.slug + '-SelectedPlan-' + (POP.currentServicePlans.json.current_plan === null ? 'new' : POP.currentServicePlans.json.current_plan.slug) + '-' + plan]);
				}

				$scope.selectedPlan = POP.currentServicePlans.json.plans[plan];
				if(ismodal)
					$scope.showModal = true;
				$scope.checkBilling();
			}

			/**
			 * Set all modal views to hidden. These are in the order they generally display/occur.
			 */
			$scope.hideModalViews = function() {
				$rootScope.showSuccess = false;
				$rootScope.showFailure = false;

				$scope.showMatrix = false;
				$scope.showCC = false;
				$scope.showChargeConfirm = false;
				$scope.showCustomFields = false;
				$scope.showConflictsConfirm = false;
				$scope.showNameserverConfirm = false;
				$scope.showUpgradeProcess = false;
				$scope.showCancelConfirm = false;
			}

			/**
			 * Determine if we need to show a credit card form, skip to final confirmation, 
			 * or skip straight to update/register based on a number of factors including 
			 * if the plan is free, if the user is billing enabled.
			 */
			$scope.checkBilling = function() {
				if(typeof POP.currentUser == 'object')
				{
					if ($scope.isSelectedPlanFree()) {
						// check if we should display custom fields next
						$scope.checkCustomFields();
					} 
					// show credit card modal if not billing enabled
					else if (POP.currentUser.status.billing_enabled == 0) {
						$scope.hideModalViews();
						$scope.showCC = true;

						// tag a potential payment attempt
						if (typeof __insp != 'undefined') {
							__insp.push(['tagSession', "payment attempt"]);
						}
					} 
					// show the billing confirmation for billing enabled user
					else {
						$scope.hideModalViews();
						$scope.showChargeConfirm = true;
						// tag a potential payment attempt
						if (typeof __insp != 'undefined') {
							__insp.push(['tagSession', "payment attempt"]);
						}
					}
				} 
				// show the billing confirmation for billing enabled user
				else {
					// tag a potential payment attempt
					if (typeof __insp != 'undefined') {
						__insp.push(['tagSession', "payment attempt"]);
					}
					$scope.hideModalViews();
					$scope.showChargeConfirm = true;
				}
			}

			/**
			 * Response handler for credit card submission.
			 */
			$scope.ccMatrixSuccess = function(resp){
				if (resp.code == 200) {
					POP.attribute('Service-' + $scope.service.slug + '-Converted-Paid');

					POP.currentUser.status.billing_enabled = 1;

					// successful credit card registration, so see if we need to check custom fields
					$scope.checkCustomFields();
				} else {
					// disable allowing form submission
					$rootScope.submitForm = false;
					POP.Message.response($('#modalMessageBox'),resp,false,true, false);
				}
			}

			$scope.ccMatrixError = function(resp) {
				POP.Message.show(
					$('#modalMessageBox'),
					"An unkown error occurred, please try again later or contact support.", 
					false
				);
			}

			/**
			 * Check custom fields.
			 */
			$scope.checkCustomFields = function() {
				// we only look for custom fields on registrations, otherwise just change plan
				if (!$scope.isNewRegistration()) {
                    $scope.changePlan();
                    return;
				}

                //only show custom fields for apps getting installed not upgraded, etc...
                //if $scope.service.settings = 0, service hasn't even been installed, check for custom fields.
				if ($scope.service.fields && $scope.service.fields.length > 0) {
					// show custom fields form
					$scope.hideModalViews();
					$scope.showCustomFields = true;
				} else {
					// no custom fields, so skip straight to checking DNS
                    $scope.checkDNS();
				}
			}

			/**
			 * Check for any DNS conflicts with currently installed services
			 */
			$scope.checkDNS = function() {
				var data = {};

				void 0;

				// prepare any dynamically populated service fields
				for (var i=0, l=$scope.service.fields.length;i<l;i++) {
					data[$scope.service.fields[i].name] = $rootScope.formServiceFields[$scope.service.fields[i].name];
				}

				void 0;

				ajaxWrapper(
					'POST', 
					data, 
					POP.apiBaseUrl + '/services/dns/' + $scope.service.slug  + '/confirm/' + POP.currentDomain.id,
                    function(resp){
						void 0;
						void 0;

						if (resp.code === 200) {
							// If we have any conflicts then update conflict message
							if (typeof resp.data.serviceConflicts != 'undefined' && resp.data.serviceConflicts != null && _.size(resp.data.serviceConflicts) > 0) {
								// handle showing conflicts
								$scope.setDnsOverlap(resp.data.serviceConflicts);

								$scope.hideModalViews();
								$scope.showConflictsConfirm = true;
							} else {
								// there are no dns conflicts so don't even show conflict window
								// and skip straight to changing plan
								$scope.changePlan();
							}
						} else if (resp.code == 409 && resp.data.externalNameservers) {
							// only show records if we have them
							if (resp.data.records && resp.data.records.length) {
								// we have nameserver issues to deal with
								$scope.showNameserverConflict(resp.data);
							} else {
								// skip straight to changing plan
								$scope.changePlan();
							}
						} else {
							// we have an error
							$rootScope.dnsOverlap = {
								error: resp.msg,
								message: null,
								service_old: null,
								service_new: null,
								domain: null
							};

							// we should be displaying errors elsewhere
							$scope.hideModalViews();
							$scope.showConflictsConfirm = true;
						}

						$rootScope.$apply();
						//$scope.$apply();
					}, function(resp) {
						// we have an error
						$rootScope.dnsOverlap = {
							error: 'An unknown error occurred.',
							message: null,
							service_old: null,
							service_new: null,
							domain: null
						};

						$scope.hideModalViews();
						$scope.showConflictsConfirm = true;
						
						$rootScope.$apply();
						$scope.$apply();

						void 0;
					}, true, $rootScope);
			};

			/**
			 * Show DNS records.
			 */
			$scope.showNameserverConflict = function(data) {
				$scope.dnsRecords = data.records;
				$scope.mailDnsRecordsAfterInstall = data.mailDnsRecordsAfterInstall;

				$scope.hideModalViews();
				$scope.showNameserverConfirm = true;
			}

			/**
			 * Handle various states for showing or hiding the DNS record overlap handler.
			 */
			$scope.setDnsOverlap = function(conflicts) {
				var msg,
					key,
					mapping = {},
					dnsOverlap = {};

				// look for messaging
				if (typeof conflicts != 'undefined' && conflicts != null && _.size(conflicts) != 0) {
					msg = [];
					for (key in conflicts) {
						msg.push(conflicts[key].message);

						// hacky overlap check
						dnsOverlap.service_old = conflicts[key].service_old;
						dnsOverlap.service_new = conflicts[key].service_new;
						dnsOverlap.domain = conflicts[key].domain;
					}
					msg = msg.join("\n ");

					dnsOverlap.message = msg;
					dnsOverlap.error = null;
				}

				void 0;
				void 0;

				$rootScope.dnsOverlap = dnsOverlap;
			}

			/**
			 * Submit any dynamically generated form fields.
			 */
			$scope.submitCustomFields = function() {
				// under the hood we just handle checking DNS (next step)
				$scope.checkDNS();
			}

			/**
			 * Called when a user decides to either overwrite or keep DNS settings.
			 */
			$scope.confirmDnsConflicts = function(skipDns) {
				// flag whether or not to skip DNS record setup
				$scope.skipDns = skipDns ? true : false;

				// go straight to changing plan
				$scope.changePlan();
			}

			/**
			 * Check if this is a new service registration or an upgrade/downgrade.
			 */
			$scope.isNewRegistration = function() {
				return POP.currentServicePlans.json.current_plan === null;
			}

			/**
			 * Handle clicking the button to actually perform the change plan.
			 */
			$scope.changePlan = function() {
				$scope.hideModalViews();
				$rootScope.showSuccessMsg = '';
				$scope.upgradeProgress = 0;
				$scope.showUpgradeProcess = true;

				void 0;
								
				// fancy fake update bar
				var interval = $interval(function() {
					if ($scope.upgradeProgress <= 90) {
						$scope.upgradeProgress += 5;
					} else {
						$interval.cancel(interval);
					}
				}, 300);

				// if there's no current plan, then this is a service registration
				if ($scope.isNewRegistration()) {
					var data = {};

					// handle selectively skipping DNS creation for the service
					data.skipDns = $scope.skipDns;

					// prepare any dynamically populated service fields
					for (var i=0, l=$scope.service.fields.length;i<l;i++) {
						data[$scope.service.fields[i].name] = $rootScope.formServiceFields[$scope.service.fields[i].name];
					}

					// set the plan
					data.plan = $scope.selectedPlan.plan_info.slug; 
					
					ajaxWrapper(
						'POST',
						JSON.stringify(data),
						POP.apiBaseUrl + '/services/' + $scope.service.slug + '/register/' + POP.currentDomain.id,
						function(resp) {
							// on success hide everything and show thank you page
							if (resp.code === 200) {
								// use our special messaging on success
								$scope.hideModalViews();
								$rootScope.showSuccessMsg = resp.msg;
								$rootScope.showSuccess = true;

								// new $scope.$apply
								$scope.$apply();
								$rootScope.$apply();

								if (typeof _kmq != 'undefined') {
									_kmq.push(['record','Service-' + $scope.service.slug + '-Registered-' + $scope.selectedPlan.plan_info.slug]);
								}

								POP.attribute('payment-success', 1);
							} else {
								POP.attribute('payment-failure', 1);
								$scope.hideModalViews();
								$rootScope.showFailure = true;

								$scope.$apply();
								$rootScope.$apply();

								POP.Message.response($('#modalMessageBox'),resp);
							}
						},
						function(error) {
							$scope.hideModalViews();
							$rootScope.showFailure = true;

							$scope.$apply();
							$rootScope.$apply();
							POP.attribute('payment-failure', 1);

							POP.Message.response($('#modalMessageBox'),error);
						}, true, $rootScope);
				} else {
					if (POP.currentService.data.service.cta.action == 'reactivate') {
						ajaxWrapper('PUT',
							null,
							POP.apiBaseUrl + '/services/' + POP.currentService.data.service.slug + '/unsuspend/' + POP.currentDomain.id,
							function(resp){
								if (resp.code == 200) {
									// success page
									$scope.hideModalViews();
									$scope.upgradeProgress = 100;
									$scope.showUpgradeProcess = false;

									$rootScope.showSuccessMsg = resp.msg;
									$rootScope.showSuccess = true;

									$scope.$apply();
									$rootScope.$apply();

									if (typeof _kmq != 'undefined') {
										_kmq.push(['record','Service-' + $scope.service.slug + '-Unsuspended']);
									}
								} else {
									$scope.hideModalViews();
									$scope.upgradeProgress = 0;
									$rootScope.showFailure = true;
			
									$scope.$apply();
									$rootScope.$apply();

									POP.Message.response($('#modalMessageBox'),resp);
								}
							},
							function(error) {
								$scope.upgradeProgress = 0;
								$scope.$apply();
								$rootScope.$apply();
								POP.Message.response($('#modalMessageBox'),error);
							}, true, $rootScope);
					} else {
						// just change the plan yo
						ajaxWrapper(
							'PUT',
							null,
							POP.apiBaseUrl + '/services/' + $scope.selectedPlan.plan_info.service_id + '/plans/' + $scope.selectedPlan.plan_info.slug + '/' + POP.currentDomain.domain,
							function(resp) {
								if (resp.code == 200) {
									// success page
									$scope.$apply(function() {
										$scope.hideModalViews();
										$scope.upgradeProgress = 100;
									});

									$rootScope.showSuccess = true;
									$rootScope.$apply();

									if(typeof _kmq != 'undefined') {
										_kmq.push(['record','Service-' + $scope.service.slug + '-Changed-' + $scope.selectedPlan.plan_info.slug]);
									}

									POP.attribute('payment-success', 1);

								} else {
									$scope.$apply(function() {
										$scope.hideModalViews();
										$scope.upgradeProgress = 0;
										$rootScope.showFailure = true;
									});

									POP.attribute('payment-failure', 1);

									void 0;
									POP.Message.response($('#modalMessageBox'),resp);
								}
							},
							function(error) {
								$scope.upgradeProgress = 0;
								$scope.$apply();
								POP.Message.response($('#modalMessageBox'),error);
							}, true, $rootScope);
						}
					}
			}

			/**
			 * Checks if the selected plan is free or not.
			 */
			$scope.isSelectedPlanFree = function() {
				if (typeof $scope.selectedPlan == 'undefined') {
					return false;
				}

				if ($scope.selectedPlan.plan_info.is_seated == 1) {
					if (parseInt($scope.selectedPlan.plan_info.amount_per_seat) == 0) {
						return true;
					} 

					return false;
				} 

				if (parseInt($scope.selectedPlan.plan_info.amount) == 0) {
					return true;
				}

				return false;
			}

			/**
			 * Return the selected plan amount.
			 */
			$scope.calculatedAmount = function() {
				if (typeof $scope.selectedPlan == 'undefined') {
					return 0;
				}

				void 0;

				if ($scope.selectedPlan.plan_info.is_seated == 1) {
					return $scope.selectedPlan.plan_info.amount_per_seat;
				} else {
					return $scope.selectedPlan.plan_info.amount;
				}
			}

			/**
			 * Textually describe what type of service action took place.
			 */
			$scope.serviceActionType = function() {
				if (POP.currentServicePlans.json.current_plan === null) {
					return 'installed';
				} else if (POP.currentService.data.service.cta.action == 'reactivate') {
					return 'unsuspended';
				} else {
					// change plan
					return 'updated';
				}
			}

			$scope.changeElement = function(){
				void 0;
			}

			//check if a plan has been passed, in that case skip matrix and getPlan
			if(typeof plan != 'undefined')
			{
				$rootScope.getPlan(plan);
			}
		}
	}
		
	return service;

});
popDirectives.directive('draggable', function() {
	return {
		restrict: 'C',
		link: function(scope, elem, attr, ctrl) {
			elem.draggable();
		}
	};
});

function ajaxWrapper(method,data,url,successcb,errorcb,overrideMsg, $rootScope) {
	$rootScope.ajax = true;

	$.ajax({
		type: method,
		url: url,
		data: data,
		timeout: 180000,
		success: function(resp) {
			$rootScope.ajax = false;
			$rootScope.$apply();

			if (overrideMsg !== true) {
				POP.Message.response($('#modalMessageBox'), resp);
			} else {
				$('#modalMessageBox').addClass('hidden');
			}

			if (successcb) {
				successcb(resp);
			}
		},
		error: function(resp){
			$rootScope.ajax = false;
			$rootScope.$apply();

			if (errorcb) {
				errorcb(resp);
			}
		},
		headers: {'X-Requested-With': 'XMLHttpRequest'},
		crossDomain: true,
		dataType:"json"
	});
}

/**
 * Create a full address string.
 */
function buildAddressString(data) {
	var address = '',
		street2 = data.address_street2;

	address += data.address_street1 + ', ';
	if (street2 && street2.length) {
		address += street2 + ', ';
	}

	return address
		+ data.address_city + ', '
		+ data.address_state + ', '
		+ data.address_country + ', '
		+ data.address_zip;
}
